<template>
  <!-- eslint-disable max-len -->
  <div>
    <section
      id="vr-base-page"
      class="amp-vr"
    >
      <div class="amp-vr__image-wrapper">
        <img
          :src="$options.PngCheck"
          alt="Blue checkbox"
          class="w-full h-full"
        >
      </div>
      <div class="amp-vr__content">
        <h3 class="amp-vr__heading">
          Next, begin updating your Voter Registration
        </h3>
        <p class="amp-vr__body font-bold mt-4">
          Completing a Change-of-Address with the U.S. Postal Service does not update your voter registration.
        </p>
        <p class="amp-vr__body">
          Just check the box and click “continue” to automatically fill out your voter registration form.
        </p>
        <div class="amp-vr__checkbox-wrapper mt-6">
          <div class="mr-4">
            <SvgThumbsUp
              v-if="autofill"
              :height="55"
              :width="55"
            />
            <SvgStopHand
              v-else
              :height="55"
              :width="55"
            />
          </div>
          <div>
            <p class="amp-vr__checkbox-heading">
              {{ autofill ? 'Smart move! We’ll prefill your form.' : 'Save time! Click to pre-fill your form.' }}
            </p>
            <InputCheckbox
              id="amp-voter-reg-checkbox"
              v-model="autofill"
              name="autofill-voter-reg"
              class="c-input-checkbox--lg mt-2"
              @input="trackAutofill"
            >
              <p class="amp-vr__copy-sm">
                Why fill out the same form again? By checking this box, you are voluntarily providing your consent
                to transfer a copy of your personal contact information to MYMOVE in order to automatically fill
                out your voter registration form and your MYMOVE registration.
              </p>
            </InputCheckbox>
          </div>
        </div>
        <button
          id="continue-vr"
          :class="{ 'c-btn--disabled': loading }"
          :disabled="loading"
          type="button"
          class="c-btn mt-6"
          @click="next('vr', $event);"
        >
          Continue
        </button>
        <div class="c-hairline mt-6" />
        <div class="amp-vr__copy-sm">
          <p class="mt-6">
            Don't need voter registration right now?
          </p>
          <button
            id="offers-no-vr"
            :class="{ 'c-link--disabled': loading }"
            :disabled="loading"
            type="button"
            class="c-link text-left mt-1"
            @click="next('offers', $event);"
          >
            Go directly to MYMOVE.com to see more offers and deals
          </button>
          <p class="mt-2">
            You will be leaving USPS.com and redirected to the MYMOVE website. Once on MYMOVE.com, you will be subject to the MYMOVE Privacy Policy and Terms and Conditions.
          </p>
        </div>
      </div>
    </section>
    <Modal
      id="reprompt-modal"
      :value="showReprompt"
      @user-dismissed="showReprompt = false;"
    >
      <div class="sp-modal">
        <SvgStopHand />
        <h3 class="sp-modal__heading mt-5">
          Make Updating Your Voter Registration Even Easier!
        </h3>
        <p class="mt-3">
          Check the box below to share the following information with MYMOVE. Doing so will autofill your voter registration form, making updating your registration quicker and easier.
        </p>
        <div class="mt-3">
          <!-- Static checkmark list -->
          <p><span class="mr-2 ml-1">&#x2714;</span>Name and Location</p>
          <p><span class="mr-2 ml-1">&#x2714;</span>Move date</p>
          <p><span class="mr-2 ml-1">&#x2714;</span>Contact information</p>
        </div>
        <InputCheckbox
          v-model="autofill"
          name="reprompt-autofill"
          class="c-input-checkbox--lg mt-4"
          @input="trackAutofill"
        >
          <p class="amp-vr__copy-sm">
            By checking Autofill and continue, you are voluntarily providing your consent to transfer a copy of your personal contact information to MYMOVE in order to automatically fill out your voter registration and your MYMOVE registration.
            Or you can continue without autofill and fill out the form again.
          </p>
        </InputCheckbox>
        <button
          id="reprompt-modal-continue"
          ref="repromptContinue"
          class="c-btn mt-4"
          @click="next('vr', $event);"
        >
          Continue
        </button>
        <p class="amp-vr__copy-sm mt-4">
          By clicking "Continue", you will be leaving USPS.com and redirected to MYMOVE.com. Once on MYMOVE.com, you will be subject to the MYMOVE Privacy Policy and Terms and Conditions
        </p>
      </div>
    </Modal>
    <Modal
      id="farewell-modal"
      :value="showFarewell"
      @user-dismissed="showFarewell = false;"
    >
      <div class="sp-modal">
        <SvgStopHand />
        <h3 class="sp-modal__heading mt-5">
          Are you sure you want to leave?
        </h3>
        <p class="mt-3">
          Avoid the hassle later and update your voter registration at MYMOVE.com now. You'll also get exclusive mover's savings from leading brands!
        </p>
        <p class="mt-3">
          Check the box below to share the following information with MYMOVE.com. Doing so will autofill your voter registration form, making updating your registration quicker and easier.
        </p>
        <div class="mt-3">
          <!-- Static checkmark list -->
          <p><span class="mr-2 ml-1">&#x2714;</span>Name and Location</p>
          <p><span class="mr-2 ml-1">&#x2714;</span>Move date</p>
          <p><span class="mr-2 ml-1">&#x2714;</span>Contact information</p>
        </div>
        <InputCheckbox
          v-model="autofill"
          name="farewell-autofill"
          class="c-input-checkbox--lg mt-4"
          @input="trackAutofill"
        >
          <p class="amp-vr__copy-sm">
            By checking Autofill and continue, you are voluntarily providing your consent to transfer a copy of your personal contact information to MYMOVE in order to automatically fill out your voter registration and your MYMOVE registration.
            Or you can continue without autofill and fill out the form again.
          </p>
        </InputCheckbox>
        <div class="sp-modal__actions mt-4">
          <button
            id="farewell-modal-continue"
            ref="farewellContinue"
            class="c-btn"
            @click="next('vr', $event);"
          >
            Continue
          </button>
          <button
            id="farewell-modal-no-thanks"
            ref="farewellNoThanks"
            class="c-btn c-btn--secondary ml-6"
            @click="next('offers', $event);"
          >
            No thanks, I only want offers
          </button>
        </div>
        <p class="amp-vr__copy-sm mt-4">
          By clicking "Continue", you will be leaving USPS.com and redirected to MYMOVE.com. Once on MYMOVE.com, you will be subject to the MYMOVE Privacy Policy and Terms and Conditions
        </p>
      </div>
    </Modal>
  </div>
</template>

<script>
import { InputCheckbox, Modal } from '@mgo/ui';
import { track } from '../../analytics/events';
import SvgStopHand from '../../components/SvgStopHand.vue';
import SvgThumbsUp from '../../components/SvgThumbsUp.vue';
import PngCheck from '../../assets/images/amp-vr-check.png';
import { validateHandoffUrl } from '../../utils/commonUtil';

export default {
  name: 'VoterRegDesktop',
  components: {
    InputCheckbox,
    Modal,
    SvgStopHand,
    SvgThumbsUp,
  },
  data() {
    return {
      autofill: JSON.parse(sessionStorage.getItem('autofill')) || false,
      debounce: null,
      loading: false,
      farewellShown: false,
      repromptShown: false,
      showFarewell: false,
      showReprompt: false,
    };
  },
  computed: {
    userNeedsReprompt() {
      return !this.autofill
        && !this.repromptShown
        && !this.farewellShown
        && !this.showReprompt
        && !this.showFarewell;
    },
  },
  created() {
    document.body.onmouseleave = (e) => {
      this.setDebounce(this.openFarewellModal, e);
    };
  },
  beforeDestroy() {
    document.body.onmouseleave = null;
    this.clearDebounce();
  },
  methods: {
    clearDebounce() {
      if (this.debounce) {
        clearTimeout(this.debounce);
        this.debounce = null;
      }
    },
    setDebounce(fn, e) {
      this.clearDebounce();
      this.debounce = setTimeout(() => {
        fn(e);
        this.clearDebounce();
      }, 100);
    },
    openFarewellModal(e) {
      if (this.showReprompt) return;

      // getElementById must match section ID for this page
      if (e.clientY <= 0 && document.getElementById('vr-base-page')) {
        document.body.onmouseleave = null;
        this.showFarewell = true;
        this.farewellShown = true;
      }
    },
    openRepromptModal() {
      if (this.showFarewell) return;

      document.body.onmouseleave = null;
      this.showReprompt = true;
      this.repromptShown = true;
    },
    trackAutofill() {
      track('ElementClicked', {
        name: `autofill-toggled-${this.autofill ? 'on' : 'off'}`,
      });
    },
    async next(flow, e) {
      this.loading = true;

      if (flow !== 'offers' && this.userNeedsReprompt) {
        track('ElementClicked', { name: 'continue-for-reprompt' });
        this.openRepromptModal();
        this.loading = false;
        return;
      }
      track('ElementClicked', { name: e.target.id });
      const { url } = await this.$coa.handoffGetURL(flow, this.autofill, this.$route.query);

      const validUrl = validateHandoffUrl(url);
      if (!validUrl) {
        this.loading = false;
        return;
      }
      window.location.href = validUrl;
    },
  },
  PngCheck,
};
</script>
